module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showIEMessage) ? _c('no-internet-explorer', {
    on: {
      "close": _vm.closeIEMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-progress-bar'), _vm._v(" "), (_vm.isFetchingReservationByID) ? _c('div', {
    staticClass: "app__progress-bar-background"
  }) : _vm._e(), _vm._v(" "), (_vm.getShowRichPrompt) ? _c('richPrompt') : _vm._e(), _vm._v(" "), _c('upgrade-plan-popup'), _vm._v(" "), _c('something-went-wrong-popup'), _vm._v(" "), _c('full-screen-loader', {
    attrs: {
      "active": _vm.getFullScreenLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app",
    class: {
      blurry: _vm.getFullScreenLoading
    }
  }, [_c('notifications', {
    attrs: {
      "position": "bottom right",
      "group": "notifications"
    }
  }), _vm._v(" "), _c(_vm.layout, {
    tag: "component"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e795e3e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2133
// module chunks = 0